export enum Events {
  TRANSAK_WIDGET_INITIALISED = 'TRANSAK_WIDGET_INITIALISED',
  TRANSAK_ORDER_CREATED = 'TRANSAK_ORDER_CREATED',
  TRANSAK_ORDER_SUCCESSFUL = 'TRANSAK_ORDER_SUCCESSFUL',
  TRANSAK_ORDER_CANCELLED = 'TRANSAK_ORDER_CANCELLED',
  TRANSAK_ORDER_FAILED = 'TRANSAK_ORDER_FAILED',
  TRANSAK_WALLET_REDIRECTION = 'TRANSAK_WALLET_REDIRECTION',
  TRANSAK_WIDGET_CLOSE = 'TRANSAK_WIDGET_CLOSE',
}
